"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.decrypt = void 0;
var base_64_1 = __importDefault(require("base-64"));
var utils_1 = require("viem/utils");
/**
 * Retrieves the version number from the body of a token.
 *
 * @param body - The body of the token.
 * @returns The version number.
 * @throws An error if the token is malformed or the version number is missing.
 */
var getVersion = function (body) {
    var match = body.match(/Web3[\s-]+Token[\s-]+Version: \d/);
    if (!match || !match.length) {
        throw new Error('Token malformed (missing version)');
    }
    return Number(match[0].replace(' ', '').split(':')[1]);
};
/**
 * Decrypts a token and returns the result.
 *
 * @param token - The token to decrypt.
 * @returns The result of the decryption.
 * @throws An error if the token is empty, not base64 encoded, unparsable JSON, or malformed in some other way.
 */
var decrypt = function (token) {
    var _a;
    if (!token || !token.length) {
        throw new Error('Token required.');
    }
    var base64_decoded = base_64_1["default"].decode(token);
    if (!base64_decoded || !base64_decoded.length) {
        throw new Error('Token malformed (must be base64 encoded)');
    }
    var body, signature;
    try {
        (_a = JSON.parse(base64_decoded), body = _a.body, signature = _a.signature);
    }
    catch (error) {
        throw new Error('Token malformed (unparsable JSON)');
    }
    if (!body || !body.length) {
        throw new Error('Token malformed (empty message)');
    }
    if (!signature || !signature.length) {
        throw new Error('Token malformed (empty signature)');
    }
    var signatureBuffer = Buffer.from(signature.slice(2), 'hex');
    var address = (0, utils_1.recoverMessageAddress)({
        message: body,
        signature: signatureBuffer
    });
    var version = getVersion(body);
    return {
        version: version,
        address: address.toLowerCase(),
        body: body,
        signature: signature
    };
};
exports.decrypt = decrypt;
